import { END_DATACHANGE } from '../constants/ActionTypes'

export function endDataChange() {
	return {
		type: END_DATACHANGE
	}
}
